export default (
  <svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#E8293B" />
    <path
      d="M8 7h2v10H8V7zm3.5 0H14c1.933 0 3.5 1.567 3.5 3.5S15.933 14 14 14h-2.5V7zm2 2v3H14a1.5 1.5 0 000-3h-0.5z"
      fill="#ffffff"
    />
  </svg>
);
